import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export const sliderPurpose = (function () {
  const init = function () {
    const swiper = new Swiper(".slider-purpose", {
      modules: [Pagination],
      spaceBetween: 20,
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        bulletElement: "button",
      },
      breakpoints: {
        1366: {
          slidesPerView: 3,
          spaceBetween: 62,
          allowTouchMove: false,
        },
      },
    });
  };

  return {
    init,
  };
})();
